import useSWR from 'swr';
import server from '../global/server';
import { useApp } from '../context/AppContext';
import useHandleErrors from './useHandleErrors';

/**
 * @param {object} options opcoes do SWR (ex.: refreshInterval para telas que
 *                 precisam acompanhar mudancas feitas por outra pessoa)
 */
export function useFetch(url, params, blocked = false, options = {}) {
    const { setLoading } = useApp();

    const fetcher = async ({ url, params }) => {
        try {
            setLoading(true);
            const { data } = await server.get(url, { params });
            return data;
        } catch (error) {
            throw error;
        } finally {
            setLoading(false);
        }
    };

    const { data, error, mutate } = useSWR(
        blocked ? null : { url, params },
        fetcher,
        {
            errorRetryCount: 1,
            ...options,
        }
    );

    return { data: data?.data, pagination: data?.pagination, meta: data, error, isLoading: !error && !data, mutate };
}
